import PortalRoleAndAssignmentTypes from "../../../types/portalRoleTypes/PortalRoleAndAssignmentTypes"
import PortalAssignmentBoilerPlate from "./PortalAssignmentBoilerPlate"
import PortalRoleBoilerplate from "./PortalRoleBoilerplate"

const PortalRoleAndAssignmentsBoilerplate: PortalRoleAndAssignmentTypes = {
    Role: PortalRoleBoilerplate,
    Assignments: [
        PortalAssignmentBoilerPlate
    ]
}

export default PortalRoleAndAssignmentsBoilerplate